import React, { useContext, useEffect, useState } from "react";
import errorIcon from "../../images/errorRedIcon.png";
import successIcon from "../../images/successGreenIcon.png";
import LoadingIcon from "../../images/Loading_icon.gif";
import { UrlContext } from "../../contexts/UrlContext";

export default function AvailabilityDate({
  date,
  expertID,
  setAvailablityDate,
  backupData,
  setBackupData,
}) {
  const [exAvailability, setExAvailability] = useState(null);
  const [returnSuccess, setReturnSuccess] = useState(false);
  const [returnError, setReturnError] = useState(false);
  const [focused, setFocused] = useState(false);
  const [loading, setLoading] = useState(false);
  const { API_URL } = useContext(UrlContext);
  useEffect(() => {
    if (date) {
      setExAvailability(date);
    }
  }, [date]);

  const handleDateChange = (e) => {
    if (e.target.value === "") {
      return;
    }
    setReturnError(false);
    setLoading(true);
    setExAvailability(new Date(e.target.value));
    setAvailablityDate(new Date(e.target.value));
    const url = `${API_URL}update-available-date`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        expertID: expertID,
        expertAvailability: e.target.value,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.status === "success") {
          setReturnSuccess(true);
          setTimeout(() => {
            setReturnSuccess(false);
          }, 1500);
          setAvailablityDate(e.target.value);
        } else {
          setExAvailability(date);
          setAvailablityDate(date);
          setReturnError(true);
          console.log(data.status);
        }
      })
      .catch((err) => {
        setExAvailability(date);
        setAvailablityDate(date);
        setLoading(false);
        setReturnError(true);
        console.log(err);
      });
  };

  return (
    <>
      {exAvailability ? (
        <input
          type="date"
          value={new Date(exAvailability).toISOString().slice(0, 10)}
          onBlur={(e) => {
            handleDateChange(e);
            setAvailablityDate(e.target.value);
          }}
          onFocus={() => setFocused(true)}
          onChange={(e) => {
            if (e.target.value === "") return;
            setExAvailability(e.target.value);
          }}
        />
      ) : (
        <input
          type="date"
          onBlur={(e) => {
            handleDateChange(e);
            setAvailablityDate(e.target.value);
          }}
          onFocus={() => setFocused(true)}
          onChange={(e) => {
            if (e.target.value === "") return;
            setExAvailability(e.target.value);
          }}
        />
      )}

      {loading && (
        <img
          className="return-msg-icon"
          style={{ top: "12px", right: "-8px" }}
          src={LoadingIcon}
          alt="loading"
          title="Loading..."
        />
      )}
      {returnSuccess && (
        <img
          className="return-msg-icon"
          style={{ top: "12px", right: "-8px" }}
          src={successIcon}
          alt="success"
          title="Success"
        />
      )}
      {returnError && (
        <img
          className="return-msg-icon"
          style={{ top: "12px", right: "-8px" }}
          src={errorIcon}
          alt="error"
          title="Error! Please reload"
        />
      )}
    </>
  );
}
